'use client'

import { useParams } from 'next/navigation'
import { ProfileNavigation } from './components/profile-navigation'
import { ProfileProvider } from './components/profile-context'
import { useNavBar } from '@components/nav/nav-provider'

export default function ProfileLayout({ children }: { children: React.ReactNode }) {
  const params = useParams()
  // Configure the nav bar to stay fixed (no scroll hiding)
  useNavBar({
    fixed: true,
    border: true
  })

  // Validate walletOrUsername parameter
  const walletOrUsername = params.walletOrUsername
  if (!walletOrUsername || typeof walletOrUsername !== 'string') {
    throw new Error('Invalid profile identifier')
  }

  return (
    <ProfileProvider walletOrUsername={walletOrUsername}>
      <div className="mt-nav-bar-height">
        {/* Navigation and Content */}
        <div className="flex flex-col md:flex-row">
          {/* Sticky Sidebar */}
          <div className="top-nav-bar-height flex-shrink-0 md:fixed md:h-[calc(100vh-var(--nav-bar-height))]">
            <ProfileNavigation walletOrUsername={walletOrUsername} />
          </div>

          {/* Main Content */}
          <div className="min-h-screen flex-1 md:ml-[216px]">
            <main>{children}</main>
          </div>
        </div>
      </div>
    </ProfileProvider>
  )
}
